module.exports = "<ui-view></ui-view>"


//////////////////
// WEBPACK FOOTER
// ./client/app/components/procedure/procedure.html
// module id = 650
// module chunks = 0